export default __webpack_public_path__ + "static/media/Food Mall.b95963c4.jpg";